import {Directive, Input, OnChanges, OnInit, SimpleChange, SimpleChanges, TemplateRef, ViewContainerRef} from '@angular/core';
import { SessionService, ApplicationRoles } from '@edl-development/edl-common';
@Directive({
    selector: '[accessControl]'
})
export class AccessControlDirective implements OnInit, OnChanges {
    @Input() accessControl: number[] = [];
    @Input() accessControlEntityOwner: string = '';
    @Input() accessControlIfCondition: boolean = true;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private sessionService: SessionService
    ) {}

    ngOnInit(): void {
        this.renderTemplate(this.accessControl, this.accessControlEntityOwner, this.accessControlIfCondition);
    }


    ngOnChanges(changes: SimpleChanges): void {
        const accessControl = this.getChange(changes['accessControl'], this.areListsEqual);
        const entityOwner = this.getChange(changes['accessControlEntityOwner']);
        const ifCondition = this.getChange(changes['accessControlIfCondition']);

        if (accessControl !== undefined || entityOwner !== undefined || ifCondition !== undefined) {
            this.renderTemplate(accessControl ?? this.accessControl, entityOwner ?? this.accessControlEntityOwner, ifCondition ?? this.accessControlIfCondition);
        }
    }

    private getChange(change: SimpleChange | undefined, isEqualFunc: (a: any, b: any) => boolean = this.isEqual) {
        const currentValue = change?.currentValue;
        const previousValue = change?.previousValue;

        return (currentValue === undefined || isEqualFunc(currentValue, previousValue)) ? undefined : currentValue;
    }

    private isEqual = (a: any, b: any) => a === b;
    private areListsEqual = (a: any[] | undefined, b: any[] | undefined) => {
        const aList = a ?? [];
        const bList = b ?? [];
        return aList.length === bList.length && aList.every((value, index) => value === bList[index]);
    }

    private renderTemplate = (accessControl: number[], entityOwner: string, ifCondition: boolean) => {
        const shouldDenyAccess = this.shouldDenyAccess(accessControl, entityOwner, ifCondition);
        this.viewContainer.clear();

        if (!shouldDenyAccess) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    private shouldDenyAccess(accessControl: number[], entityOwner: string, ifCondition: boolean) {
        try{
            if (!ifCondition) {
                return true;
            }
            else if (accessControl.indexOf(ApplicationRoles.OWNER) > -1 && entityOwner === this.sessionService.user?.UserID) {
                return false;
            }
            else if (this.sessionService.user && accessControl.indexOf(this.sessionService.user.AccessRoleID) > -1) {
                return false;
            }
    
            return true;
        }catch(err) {
            console.log(err);
            return false;
        }
        
    }
}